import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import "../../../utilites/Card.css";
// import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ReactApexChart from "react-apexcharts";
import DoubleRingDonutChart from "../../../pages/exp-temp/DoubleRingDonutChart";
const DonutsCard1 = (props) => {
 
  const fillValue11 = 60;
  const staticVal1 = 100;

  const staticTiming1 = 30;

  const [fillValue21, setFillValue21] = useState(28);

  const [chartWidth1, setChartWidth1] = useState(300);
  const [chartHeight1, setChartHeight1] = useState(300);

  const staticDataOuter1 = [
    { label: "Base", value: fillValue11, color: "#ff6347" },
    {
      label: "Static",
      value: staticVal1 >= fillValue11 ? staticVal1 - fillValue11 : 0,
      color: "#ccc",
    },
  ];

  const staticDataInner1 = [
    {
      label: "Base",
      value: fillValue21,
      color: fillValue21 > 0 ? "#00bfff" : "#ccc",
      borderColor: fillValue21 == 0 ? "#00bfff" : "#ccc",
    },
    {
      label: "Static",
      value: fillValue21 > staticTiming1 ? fillValue21 - staticTiming1 : 0,
      color: "#ccc",
      borderColor: "#ccc",
    },
  ];
  return (
    <>
      <Card className="endingStyle">
        {/* {props.middle} */}
        {/* <Container> */}
        <Row style={{ minWidth: "100%" }}>
          {props?.user ? (
            <h5 style={{ textAlign: "left", paddingBottom: "10px" }}>
              {(props?.user?.firstName ?? "") +
                " " +
                (props?.user?.lastName ?? "")}
            </h5>
          ) : (
            <h5
              style={{
                textAlign: "left",
                paddingBottom: "10px",
              }}
            >
              James Smith
            </h5>
          )}
          <Col lg={6}>
            <p style={{ fontSize: 14 }}>{props.left}</p>
            <p className="green" style={{ fontSize: "24px" }}>
              {props?.user?.average ? props?.user?.average : 0}
            </p>
          </Col>

          <Col lg={6}>
            <p style={{ fontSize: 14 }}>{props.last}</p>
            <p className="green" style={{ fontSize: "24px" }}>
              {props?.user?.highestCount ? props?.user?.highestCount : 0}
            </p>
          </Col>
          <Col lg={12}>
            <h6 style={{ paddingTop: "15px" }}>Today</h6>
            <div style={{ marginTop: 20 }}>
              <svg width="300" height="100">
                <g>
                  <rect x="10" y="10" width="20" height="20" fill="#ff6347" />
                  <text x="40" y="25" fontSize="14" fill="#fff">
                    Count: 60(Target:100)
                  </text>
                </g>

                <g>
                  <rect x="10" y="40" width="20" height="20" fill="#00bfff" />
                  <text x="40" y="55" fontSize="14" fill="#fff">
                    Avg. Time: 28 mins(Target: 30 mins)
                  </text>
                </g>
              </svg>
            </div>
            <DoubleRingDonutChart
              staticData={staticDataOuter1}
              dynamicData={staticDataInner1}
              chartWidth={chartWidth1}
              chartHeight={chartHeight1}
            />
          </Col>
        </Row>
        {/* </Container> */}
      </Card>
    </>
  );
};

export default DonutsCard1;
// checked
